module.exports = __webpack_public_path__ + "img/affiliates_banner.6ce69cb0.png";